import {
  AssetRoutineState,
  RoutineState,
  WorkflowQuestionConfig,
  WorkspaceAsset,
} from '@gripp/shared-logic';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { tokens } from '../../../crop-circle/tokens';
import { RenderMediaSourcExecutionForm } from '../../components/renderMediaSource';
import { RoutineQuestionModules } from '../questions/routineQuestionModules';
import { stylesCropCircle } from './styles';

type WorkflowExecutionQuestionProps = {
  config: WorkflowQuestionConfig;
  questionIndex: number;
  responseIndex: number;
  workspaceAsset: WorkspaceAsset;
  toggleProcessing?: (value: boolean) => void;
  currentState: AssetRoutineState<RoutineState> | undefined;
  isIssueEditRoutine?: boolean;
  idpEnabled?: boolean;
  captureLocally?: boolean;
};

export const WorkflowExecutionQuestion = (
  props: WorkflowExecutionQuestionProps
) => {
  const ExecutionForm = RoutineQuestionModules[props.config.type].executionForm;

  return (
    <View style={stylesCropCircle.questionContainer}>
      <View style={stylesCropCircle.questionTitleContainer}>
        <Text style={tokens.typography.label.largeEmphasised}>
          {props.questionIndex + 1}. {props.config.instructions}
        </Text>
      </View>

      {props.config?.media ? (
        <RenderMediaSourcExecutionForm value={props.config?.media} />
      ) : null}
      <ExecutionForm
        config={props.config}
        responseIndex={props.responseIndex}
        workspaceAsset={props.workspaceAsset}
        toggleProcessing={props.toggleProcessing}
        currentState={props.currentState}
        isIssueEditRoutine={props.isIssueEditRoutine}
        idpEnabled={props.idpEnabled}
        captureLocally={props.captureLocally}
      />
    </View>
  );
};
